import { render, staticRenderFns } from "./coreObjectFit.vue?vue&type=template&id=36422a5a&"
import script from "./coreObjectFit.vue?vue&type=script&lang=js&"
export * from "./coreObjectFit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "coreObjectFit.vue"
export default component.exports